module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Comitente")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "form-control w-auto w-full-xs",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.isLoading ? 'Carregando' : 'Selecione'))]), _vm._v(" "), _vm._l((_vm.comitentes), function(comitente) {
    return _c('option', {
      key: comitente.id,
      domProps: {
        "value": comitente.id
      }
    }, [_vm._v(_vm._s(comitente.nome) + " - " + _vm._s(comitente.tipo == 1 ? comitente.cpf : comitente.cnpj) + _vm._s(comitente.grupo ? ' - ' + comitente.grupo : ''))])
  })], 2), _vm._v(" "), (_vm.loadError) ? _c('a', {
    staticClass: "btn text-danger",
    on: {
      "click": _vm.load
    }
  }, [_vm._v("Não foi possível carregar. Tente novamente")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b49e77e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/SelectComitente.vue
// module id = 1615
// module chunks = 17